/* jshint browserify: true */
'use strict';

var PubSub = require('../App/lib/pubsub').default;
var pubSubService = {};

pubSubService.EVENT_STARTED_VIDEO = 'Started Video';
pubSubService.EVENT_VIEW_BEGINNING_VIDEO = 'Viewed beginning Video';
pubSubService.EVENT_STOPPED_VIDEO = 'Stopped Video';
pubSubService.EVENT_VIEWED_ELEMENT = 'Viewed Element';

pubSubService.EVENT_HITS_DISPLAYED = 'Hits displayed';
pubSubService.WANTED_TO_CONTACT_US = 'Wanted to Contact Us';

pubSubService.subscribe = PubSub.get().subscribe;
pubSubService.publish = PubSub.get().publish;
module.exports = pubSubService;
